























































































































































































































































































































































































































































import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import CountryFlag from 'vue-country-flag';
import moment from 'moment';
import DateHandler from '@/shared/utils/date-format';
import AddButton from '@/shared/buttons/add-button.component.vue';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import ModalComponent from '@/shared/modal/modal.component.vue'
import PushOrderUtils from '@/shared/utils/push-order-utils';
import toDocument from '@/shared/directive/toDocument';
import { VMoney } from 'v-money';
import MainButton from '@/shared/buttons/main-button.component.vue';
import CancelContractRequest from '@/domain/contract/request/cancel-contract.request';
import CancelContractGroupRequest from '@/domain/contract/request/cancel-contract-group.request';
import ContractPersist from '@/domain/contract/entity/contract-persist.entity';
import ContractService from '@/domain/contract/service/contract.service';
import ContractGroupService from '@/domain/contract/service/contract-group.service';
import routeTo from '@/router/routeTo';
import Rules from '@/shared/rules/rules';
import Contract from '@/domain/contract/entity/contract.entity';
import FilterUtils from '@/shared/utils/filters';
import UserAuthority from '@/domain/security/user-authority.service';
import CancelModal from './cancel-modal.component.vue';
import CancelGroupModal from './cancel-group-modal.component.vue';
import ReOpenContractModal from './reopen-contract-modal.component.vue';
import RemoveContractFromContractGroup from './contract-group-remove-modal.component.vue';
import ConnectContractToContractGroup from './contract-group-connect-modal.component.vue';
import PushOrderModal from './push-order-modal.component.vue';

@Component({
  filters: {
    formatDate(value: string) {
      if (!value) return '-';
      return DateHandler.timestampToLocal(value);
    },
    timestampToSimpleLocal(value: string) {
      return DateHandler.timestampToSimpleLocal(value);
    },
    fullDateAndTime(value: string) {
      return DateHandler.fullDateAndTime(value);
    },
    toCurrency: VbDirectives.toCurrency,
    toDocument(value: String): String {
      return toDocument(value);
    },
  },
  directives: {
    money: VMoney,
  },
  components: {
    MainButton,
    AddButton,
    ModalComponent,
    CancelModal,
    CancelGroupModal,
    VbTooltipSlot,
    CountryFlag,
    ReOpenContractModal,
    RemoveContractFromContractGroup,
    ConnectContractToContractGroup,
    PushOrderModal,
  },
})
export default class ContractContent extends Vue {
  @Prop({
    required: true,
  })
  contract!: Contract;

  @Prop({
    required: true,
    default: false,
  })
  editModeValue!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop() userAuthority!: UserAuthority;

  @Prop({
    required: true,
    default: false,
  }) enabledContractFlow!: boolean;

  @Prop() enableRevision!: boolean;

  rules: Rules = new Rules();

  ref: any = this.$refs;

  showCancelModal: boolean = false;

  showCancelGroupModal: boolean = false;

  showReOpenModal: boolean = false;

  showReOpenGroupModal: boolean = false;

  showRemoveFromGroupModal: boolean = false;

  showContractGroupTooltip: boolean = false;

  showContractPlanTooltip: boolean = false;

  showAddToGroupModal: boolean = false;

  showConnecToGroupModal: boolean = false;

  showModalPushOrder: boolean = false;

  cancelModalKey = Math.floor(Math.random() * 10000);

  cancelModalGroupKey = Math.floor(Math.random() * 10000);

  cancelReOpenModalKey = 100;

  cancelReOpenGroupModalKey = Math.floor(Math.random() * 10000);

  showRequestCancelContractModal: boolean = true;

  labelMinimumBillingAmount = 'Valor Mínimo Faturamento';

  get editMode(): object {
    return {
      color: this.editModeValue ? 'lightGreen' : 'lightBlue',
      text: this.editModeValue ? 'Editando' : 'Editar',
      icon: !this.editModeValue,
    }
  }

  get modalOptions(): object {
    return {
      color: 'warning',
      text: 'Cancelar',
    }
  }

  get modalReOpenOptions(): object {
    return {
      color: 'warning',
      text: 'Reabrir',
    }
  }

  get contractEnabled() {
    return this.contract.billing.enabled;
  }

  get contractReviewed() {
    return this.contract.reviewed
  }

  isPushOrder() {
    return this.contract.pushOrderNumber != null
      && this.contract.pushOrderExpirationDate != null;
  }

  get buttonPushOrderColor() {
    if (!this.isPushOrder()) return PushOrderUtils.COLOR_WARNING;
    return PushOrderUtils.getColor(this.contract.pushOrderExpirationDate);
  }

  get pushOrderIcon() {
    return PushOrderUtils.getIcon();
  }

  get getPushOrderTooltipContent() {
    if (!this.isPushOrder()) return 'Necessita de PO';
    return PushOrderUtils.getLegend(this.contract.pushOrderExpirationDate);
  }

  setMinimumBilligAmountValue(value: any) {
    const numberValue: number = Number(FilterUtils.formatValue(value));
    this.contract.minimumBillingAmount = numberValue;
  }

  set contractEnabled(value: any) {
    this.$emit('contractEnabledUpdate', value);
  }

  openCancelModal() {
    this.showCancelModal = true;
  }

  openCancelGroupModal() {
    this.showCancelGroupModal = true;
  }

  closeModal() {
    this.showCancelModal = false;
  }

  closeModalGroup() {
    this.showCancelGroupModal = false;
  }

  closeReOpenModal() {
    this.showReOpenModal = false;
    this.cancelReOpenModalKey += 1;
  }

  closeReOpenGroupModal() {
    this.showReOpenGroupModal = false;
  }

  get validBody(): boolean {
    return this.ref.form.validate();
  }

  cancelContractGroup(request: CancelContractGroupRequest) {
    ContractGroupService.cancelAllItensFromContractGroup(
      this.contract.contractGroup.id,
      request,
    )
      .then((_response: any) => {
        VbSnackbarService.showSuccess('Cancelamento de todos contratos do grupo efetuado com sucesso');
        this.showCancelGroupModal = false;
        this.cancelModalGroupKey += 1;
        this.refreshContract();
      })
      .catch(VbSnackbarService.handleHttpError)
  }

  cancelContract(request: CancelContractRequest) {
    ContractService.cancelContract(this.businessUnitId, this.contract.id, request)
      .then((_response: any) => {
        VbSnackbarService.showSuccess('Cancelamento efetuado com sucesso');
        this.showCancelModal = false;
        this.cancelModalKey += 1;
        this.refreshContract();
      })
      .catch(VbSnackbarService.handleHttpError)
  }

  showTooltip(): String {
    return this.contract.billing.enabled
      ? 'Desabilitar Faturamento'
      : 'Habilitar Faturamento'
  }

  hasInactivationHistoryAndContractDisabled() {
    return this.contract.hasInactivation && this.contract.billing.enabled;
  }

  goToBillings(externalId: number): void {
    const route: any = {
      path: `/billing?contractId=${externalId}`,
    };
    routeTo(this.$router, route);
  }

  @Emit('updateContract')
  updateContract(): ContractPersist {
    return ContractPersist.of(this.contract);
  }

  @Emit('cancel')
  cancel(): void {}

  @Emit('enableEdition')
  enableEdition(): void {
    if (!this.editModeValue) {
      this.$emit('handleLoadAdditionalInf');
    }
  }

  @Emit('refreshContract')
  refreshContract(): void {}

  handleBillingSwitch() {
    if (!this.userAuthority.isAdminOrSupervisor()) return
    this.$emit('handleBillingSwitch');
  }

  checkIsEnableRevision(): boolean {
    return this.contract.contractModel === 'ASSISTED_PURCHASE' && this.enableRevision;
  }

  hasContractGroup() {
    return (this.contract.contractGroup.id && this.userAuthority.isAdminOrSupervisor());
  }

  handleRequestExpirationContractSwitch() {
    if (!this.userAuthority.canChangeExpirationContract()) return false;
    if (this.contract.cancellationRequest.markedToExpire) {
      return this.$emit('handleCancelExpirationRequestSwitch');
    }
    return this.$emit('handleRequestExpirationContractSwitch');
  }

  handlePreviewSwitch() {
    if (this.userAuthority.isAdminOrSupervisor()) {
      return this.$emit('handlePreviewSwitch', this.contract.isPreview);
    }
    return false;
  }

  handleCustomBillingSwitch() {
    if (this.userAuthority.canManageCalculation()) {
      return this.$emit('handleCustomBillingSwitch', this.contract.isCustomBilling);
    }
    return false;
  }

  handleBillingDaily() {
    if (this.userAuthority.canManageCalculation()) {
      return this.$emit('handleBillingDaily', this.contract.isBillingDaily);
    }
    return false;
  }

  handleBillingPushOrderSwitch() {
    if (this.userAuthority.canManageCalculation()) {
      return this.$emit('handleBillingPushOrderSwitch', this.contract.isBillingPushOrder);
    }
    return false;
  }

  handleReviewedSwitch() {
    if (this.userAuthority.canManageCalculation()) {
      return this.$emit('handleReviewedSwitch');
    }
    return false;
  }

  getTooltipMessageRequestExpiration() {
    return this.contract.cancellationRequest.markedToExpire ? 'Reverter Solicitação de Encerramento' : 'Solicitar Encerramento'
  }

  getMessageContractIsPreview() {
    return this.contract.isPreview ? 'Contrato está definido como Prévia' : 'Definir contrato como Prévia'
  }

  getMessageContractIsCustomBilling() {
    return this.contract.isCustomBilling ? 'Contrato está definido como Faturamento Personalizado' : 'Definir contrato como Faturamento Personalizado'
  }

  getMessageContractIsBillingDaily() {
    return this.contract.isBillingDaily ? 'Contrato está no modo de faturamento diário' : 'Definir modo de faturamento diário para o contrato'
  }

  getMessageContractIsBillingWithPushOrder() {
    return this.contract.isBillingPushOrder
      ? 'Contrato está no modo de faturamento com Ordem de Compra (Push Order)'
      : 'Definir modo de faturamento com Ordem de Compra (Push Order) para o contrato'
  }

  getMessageContractIsReviewed() {
    return this.contract.reviewed
      ? 'Contrato está definido como "Revisado"'
      : 'Contrato está definido como "Não Revisado"'
  }

  openPushOrderModal(): void {
    this.showModalPushOrder = true;
  }

  cancelPushOrder(): void {
    this.showModalPushOrder = false;
  }

  handleReOpenContract(justificationText: string) {
    ContractService.reOpenContract(this.businessUnitId, this.contract.id, justificationText)
      .then((_response: any) => {
        VbSnackbarService.showSuccess('Reabertura realizada com sucesso!');
        this.showReOpenModal = false;
        this.cancelReOpenModalKey += 1;
        this.refreshContract();
      })
      .catch(VbSnackbarService.handleHttpError)
  }

  handleReOpenContractGroup(justificationText: string) {
    ContractGroupService.reopenAllItemsForContractGroup(
      this.contract.contractGroup.id,
      justificationText,
    )
      .then((_response: any) => {
        VbSnackbarService.showSuccess('Reabertura dos Contratos do Grupo de Contratos realizado com sucesso!');
        this.showReOpenGroupModal = false;
        this.cancelReOpenModalKey += 1;
        this.refreshContract();
      })
      .catch(VbSnackbarService.handleHttpError)
  }

  handleReOpenContractGroupClick() {
    this.showReOpenGroupModal = true;
  }

  handleReOpenContractClick() {
    this.showReOpenModal = true;
  }

  handleRemoveFromGroup() {
    this.showRemoveFromGroupModal = true;
  }

  handleAddToGroup() {
    this.showAddToGroupModal = true;
  }

  handleConnectContract() {
    this.showConnecToGroupModal = true;
  }

  refreshContractGroup() {
    this.showAddToGroupModal = false;
    this.showConnecToGroupModal = false;
    this.showRemoveFromGroupModal = false;
    this.refreshContract();
  }

  money: object = {
    decimal: ',',
    thousands: '.',
    precision: 2,
    prefix: 'R$ ',
    masked: false,
  }
}
